import { Box } from "@mui/material";
import LanguageContext from "components/LanguageContext";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import EulerianService from "services/EulerianService";
import {
  DMYToDate,
  fullNumericFormatDate,
  getFileExtension,
  getFileNameWithoutExtension,
  getSize,
} from "utils/commonUtils";
import t from "utils/locales/translation.json";
import { getFilenameFromUrl, normalized } from "utils/urlUtils";

const Attachment = (props) => {
  const {
    title = "",
    linkText = "",
    file = { name: "", url: "", size: null, lastUpdate: "", updated: "" },
    description = "",
    publishDate = false,
    link = false,
  } = props;
  const { language } = useContext(LanguageContext);

  let { name, url } = file || {};
  const { id: fileId, size, lastUpdate, updated, mimeType } = file || {};
  const extensionFile = getFileExtension(name)?.replace(".", "") || "";
  const sendTag = () => {
    EulerianService.sendClick({ download: [`${extensionFile}::download::${title || "piece jointe"}`] });
  };

  if ((name || title) && url && (url.startsWith(process.env.ged_public_url) || url.startsWith("/files"))) {
    const filename = getFilenameFromUrl(url);
    const fileNameWithoutExtension = getFileNameWithoutExtension(filename);
    if (!name) {
      name = `${normalized(title)}${getFileExtension(filename)}`;
    }
    if (name !== getFileExtension(name)) {
      url = url.replace(filename, `${fileNameWithoutExtension}/${name}`);
    }
  } else if (!name && url) {
    name = getFilenameFromUrl(url);
  }

  const dataAssesFile = useMemo(() => (!!mimeType && !!size ? { "data-fr-assess-file": true } : {}), [mimeType, size]);

  if (link)
    return (
      <Box
        component="a"
        download={name && name !== getFileExtension(name) ? name : fileId}
        href={url}
        onClick={sendTag}
        target="_blank"
        rel="noopener noreferrer"
        className="fr-link fr-link--download"
        sx={{ position: "unset", "& .fr-link__detail": { bottom: 12 } }}
      >
        {linkText}
        {(name || size) && (
          <span className="fr-link__detail">{`${
            t[language].components.pj_link_download
          } ${extensionFile.toUpperCase()}${name && size ? " – " : " "}${
            size
              ? getSize({
                  size,
                  unity: 0,
                })
              : ""
          }`}</span>
        )}
      </Box>
    );

  return (
    <div className="fr-card fr-enlarge-link fr-card--horizontal fr-card--download">
      <div className="fr-card__body">
        <div className="fr-card__content">
          <h3 className="fr-card__title">
            <a
              {...dataAssesFile}
              download={name && name !== getFileExtension(name) ? name : fileId}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={sendTag}
            >
              {linkText}
            </a>
          </h3>
          <p className="fr-card__desc">{description}</p>
          {(lastUpdate || updated) && publishDate && (
            <div className="fr-card__start">
              <p className="fr-card__detail fr-icon-calendar-event-fill">{`${
                t[language].components.pj_publishDate
              } ${fullNumericFormatDate({ date: lastUpdate ? DMYToDate(lastUpdate) : updated, lang: language })}`}</p>
            </div>
          )}
          <div className="fr-card__end">
            <p className="fr-card__detail" />
          </div>
        </div>
      </div>
    </div>
  );
};

Attachment.propTypes = {
  title: PropTypes.string,
  linkText: PropTypes.string,
  file: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    size: PropTypes.PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lastUpdate: PropTypes.string,
    updated: PropTypes.string,
  }),
  publishDate: PropTypes.bool,
  description: PropTypes.string,
  link: PropTypes.bool,
};

export default Attachment;
